var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"back-icon",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('BackIcon')],1),_c('iframe',{staticStyle:{"width":"100%","height":"93vh"},attrs:{"src":_vm.$route.query,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }